import { withSentryRouting } from '@upflowy/logger';
import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import NotFound from './NotFound';
import { Offline } from './Offline';
import Version from './Version';

import { VersionProvider } from '../contexts/Version';
import { FlowConfigProvider } from '../providers/flow-config-provider';

const SentryRoute = withSentryRouting(Route);

const Routes = () => (
  <Router>
    <Switch>
      <SentryRoute path="/offline" component={Offline} />
      <SentryRoute
        path="/preview/template/:templateId"
        render={() => (
          <FlowConfigProvider>
            <VersionProvider>
              <Version />
            </VersionProvider>
          </FlowConfigProvider>
        )}
      />
      <SentryRoute
        path="/preview/:flowId/:versionId"
        render={() => (
          <FlowConfigProvider>
            <VersionProvider>
              <Version />
            </VersionProvider>
          </FlowConfigProvider>
        )}
      />
      <SentryRoute
        path="/flow/:flowId"
        render={() => (
          <FlowConfigProvider>
            <VersionProvider>
              <Version />
            </VersionProvider>
          </FlowConfigProvider>
        )}
      />
      <SentryRoute
        path="/:customURL"
        render={() => (
          <FlowConfigProvider>
            <VersionProvider>
              <Version />
            </VersionProvider>
          </FlowConfigProvider>
        )}
      />
      <Route component={NotFound} />
    </Switch>
  </Router>
);

export default Routes;
